import {AbstractControl, ValidatorFn} from '@angular/forms';

/*
 * Returns 1 if the IBAN is valid
 * Returns FALSE if the IBAN's length is not as should be (for CY the IBAN Should be 28 chars long starting with CY )
 * Returns any other number (checksum) when the IBAN is invalid (check digits do not match)
 */
function isValidIBANNumber(input): boolean {
  const CODE_LENGTHS = {
    PL: 28,
  };
  const iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, '');
  const code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);
  let digits;
  if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
    return false;
  }
  digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, (letter: any) => {
    return (letter.charCodeAt(0) - 55).toString();
  });
  return mod97(digits) === 1;
}

function mod97(text: string): any {
  let checksum: number = parseInt(text.slice(0, 2), 10);
  let fragment;

  for (let offset = 2; offset < text.length; offset += 7) {
    fragment = String(checksum) + text.substring(offset, offset + 7);
    checksum = parseInt(fragment, 10) % 97;
  }
  return checksum;
}

export function validIban(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null =>
    (!control.value || control.value === 'PL' || isValidIBANNumber(control.value))
      ? null : {invalidIban: true};
}
